export default {"src":"/_next/static/media/icon-star-attachment.91d19fdb.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};